import { fetchFromContentful } from './utils';
export const fetchBanners = async () => {
    const contentfulData = await fetchContentfulBanners();
    return contentfulData.map((item) => ({
        pathMobile: item.mobileBanner.url,
        pathDesktop: item.desktopBanner.url,
        link: item.url,
    }));
};
const query = `
{
  bannerCollection {
    items {
      url
      mobileBanner {
        url
      }
      desktopBanner {
        url
      }
    }
  }
}
`;
const fetchContentfulBanners = async () => {
    const response = await fetchFromContentful(query);
    return response.bannerCollection.items;
};
